import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../Api/Api";
import endpoints from "../../Api/Endpoints";

export const adminLogin = createAsyncThunk(
  "auth/adminLogin",
  async (data, { rejectWithValue }) => {
    try {
      // ✅ exact body like Postman
      const payload = {
        mobile: String(data?.mobile ?? "").trim(),
        password: String(data?.password ?? ""),
      };

      const res = await API.post(endpoints.ADMIN_LOGIN, payload);

      return res.data;
    } catch (error) {
      // ✅ better error extraction for 400 responses
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        (Array.isArray(error?.response?.data?.errors)
          ? error.response.data.errors[0]
          : null) ||
        error?.message ||
        "Login Failed";

      return rejectWithValue(msg);
    }
  }
);